import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { Button, Tooltip } from 'antd';
import { styled } from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var QuestionItem = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  padding: 8px;\n  width: 37px;\n  height: 37px;\n\n  border: ", ";\n  border-radius: 8px;\n  color: ", ";\n  background-color: ", ";\n"])), function (props) {
  if (props.danger) {
    return "1px solid ".concat(styleVariables.colors.red5);
  }

  return props.active ? "1px solid ".concat(styleVariables.colors.blue1) : "1px solid ".concat(styleVariables.colors.gray9);
}, function (props) {
  if (props.danger) {
    return "1px solid ".concat(styleVariables.colors.red4);
  }

  return props.active ? styleVariables.colors.blue3 : styleVariables.colors.gray11;
}, function (props) {
  if (props.danger) {
    return styleVariables.colors.red5;
  }

  return props.active ? styleVariables.colors.blue1 : styleVariables.colors.gray1;
});
export var QuestionSummaryButton = function QuestionSummaryButton(props) {
  var onClick = props.onClick,
      active = props.active,
      disabled = props.disabled,
      questionIndex = props.questionIndex,
      tooltipText = props.tooltipText,
      danger = props.danger;

  var questionItemButton = function questionItemButton() {
    return /*#__PURE__*/_jsx(QuestionItem, {
      onClick: onClick,
      disabled: disabled,
      active: active,
      size: "small",
      danger: danger,
      children: questionIndex
    });
  };

  var renderContent = function renderContent() {
    if (tooltipText) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: tooltipText,
        children: questionItemButton()
      });
    }

    return questionItemButton();
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderContent()
  });
};